import {Tabs} from '../../../ui-library';
import {TabBox, TabTitle} from '../Style/AutoProjectStatusTabs.style';
import {_SYSTEM_TITLES} from '../../../configuration/SystemTitles/SystemTitles.config';
import React from 'react';
import {IPropsView} from '../Config/AutoProjectStatusTabs.types';


const AutoProjectStatusTabsView = ({value, handleChange}: IPropsView) => (
    <TabBox>
        <Tabs value={value} onChange={handleChange}>
            <TabTitle label={_SYSTEM_TITLES.imageCollectionTabLabel}/>
            <TabTitle label={_SYSTEM_TITLES.trainingTabLabel}/>
        </Tabs>
    </TabBox>
);

export default AutoProjectStatusTabsView;
